import React from 'react';
import '../components/HomeView/Home.css'
import {TopMenuLinks} from "../components/HomeView/TopMenuLinks";
import {TopMenuLogo} from "../components/HomeView/TopMenuLogo";
import {PaintingItem} from "../components/PaintingView/PaitingItem";
import ObLifeguardStation1 from './../img/paintings/IMG_5297.jpg'
import pic2 from './../img/paintings/IMG_4800.jpg'
import pic3 from './../img/paintings/IMG_5246.jpg'
import pic4 from './../img/paintings/IMG_5263.jpg'
import pic5 from './../img/paintings/IMG_5286.jpg'

import pic6 from './../img/paintings/IMG_1.jpg'
import pic7 from './../img/paintings/IMG_2.jpg'
import pic8 from './../img/paintings/IMG_3.jpg'
import pic9 from './../img/paintings/IMG_4.jpg'
import pic10 from './../img/paintings/IMG_5.jpg'
import pic11 from './../img/paintings/IMG_6.jpg'
import pic12 from './../img/paintings/IMG_7.jpg'
import pic13 from './../img/paintings/IMG_8.jpg'
import pic14 from './../img/paintings/IMG_9.jpg'
import pic15 from './../img/paintings/IMG_10.jpg'
import pic16 from './../img/paintings/IMG_11.jpg'
import pic17 from './../img/paintings/IMG_12.jpg'
import pic18 from './../img/paintings/IMG_13.jpg'
import pic19 from './../img/paintings/IMG_14.jpg'
import pic20 from './../img/paintings/IMG_15.jpg'
import pic21 from './../img/paintings/IMG_16.jpg'
import pic22 from './../img/paintings/IMG_17.jpg'
import pic23 from './../img/paintings/IMG_18.jpg'
import pic24 from './../img/paintings/IMG_19.jpg'
import pic25 from './../img/paintings/IMG_25.jpg'
import pic26 from './../img/paintings/IMG_26.jpg'
import pic27 from './../img/paintings/IMG_27.jpg'
import pic28 from './../img/paintings/IMG_28.jpg'
import pic29 from './../img/paintings/IMG_29.jpg'
import pic30 from './../img/paintings/IMG_30.jpg'
import pic31 from './../img/paintings/IMG_31.jpg'
import pic32 from '../img/paintings/IMG_32.jpg'
import pic33 from '../img/paintings/IMG_33.jpg'
import pic34 from '../img/paintings/IMG_34.jpg'
import pic35 from '../img/paintings/IMG_35.jpg'
import pic36 from '../img/paintings/IMG_36.jpg'
import pic37 from '../img/paintings/IMG_37.jpg'
import pic38 from '../img/paintings/IMG_38.jpg'
import pic39 from '../img/paintings/IMG_39.jpg'
import pic40 from '../img/paintings/IMG_40.jpg'
import pic41 from '../img/paintings/IMG_41.jpg'

import {MobileSearchBar} from "../components/HomeView/MobileSearchBar";


export const PaintingView = () => {

    return <div className='PageBackground'>
        <TopMenuLogo/>
        <MobileSearchBar/>
        <TopMenuLinks/>
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            height: '100%',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            {/*message*/}
            <div style={{backgroundColor: 'rgb(48,93,150)', width: '100%', padding: '1%'}}>
                <div style={{textAlign: 'center', fontSize: 18, color: 'white'}}>Sometimes I like to go sit outside and paint things. I
                only started about 5 years ago. Typically I use some combination of watercolors, silver/gold leaf, Sakura Micron fineliner pens, and fountain
                pen.
                </div>
            </div>
            <PaintingItem name={'Ocean Beach Hotel - San Diego'} picture={pic32}/>
            <PaintingItem name={'Ocean Beach Pier'} picture={pic23}/>
            <PaintingItem name={'The Joint - Ocean Beach'} picture={pic28}/>
            <PaintingItem name={'California Tower and Building - San Diego'} picture={pic34}/>
            <PaintingItem name={'OB Pier (or What\'s Left) - San Diego'} picture={pic38}/>
            <PaintingItem name={'Santa Cruz Beach - Ocean Beach'} picture={pic22}/>
            <PaintingItem name={'Marina - Cabo San Lucas, MX'} picture={pic40}/>


            <PaintingItem name={'Newbreak Coffee - Ocean Beach'} picture={pic18}/>
            <PaintingItem name={'Santa Cruz Beach - San Diego'} picture={pic35}/>
            <PaintingItem name={'Ocean Beach Lifeguard Station - San Diego'} picture={pic36}/>
            <PaintingItem name={'Downtown San Diego'} picture={pic5}/>

            <PaintingItem name={'OB Pier (Gifted to TwoBear\'s Dye) - San Diego'} picture={pic39}/>

            <PaintingItem name={'Desert Camping (Gifted to Allison\'s Sister) - Somewhere Hot, CA'} picture={pic41}/>
            <PaintingItem name={'Leo Carrillo\'s Barn - San Diego'} picture={pic37}/>
            <PaintingItem name={'Embarcadero Marina Park - San Diego'} picture={pic31}/>
            <PaintingItem name={'Vignettes - Ocean Beach'} picture={pic30}/>
            <PaintingItem name={'SunShine DayDreams - Ocean Beach'} picture={pic29}/>

            <PaintingItem name={'Surfside Cottages - Ocean Beach'} picture={pic19}/>
            <PaintingItem name={'Lifeguard Station Ocean Beach'} picture={pic20}/>
            <PaintingItem name={'Desert Rose Care Shop - Little Italy'} picture={pic21}/>


            <PaintingItem name={'Lifeguard Station Ocean Beach'} picture={ObLifeguardStation1}/>
            <PaintingItem name={'Lifeguard Tower 3 - Ocean Beach'} picture={pic25}/>
            <PaintingItem name={'Willow Springs - Tamms, IL'} picture={pic27}/>
            <PaintingItem name={'Mona Lisa Deli - San Diego'} picture={pic33}/>
            <PaintingItem name={'Ocean Beach Pier'} picture={pic4}/>
            <PaintingItem name={'Ocean Beach Pier'} picture={pic3}/>
            <PaintingItem name={'Willow Springs Music Festival'} picture={pic2}/>

            <PaintingItem name={'Diesel Dick\'s'} picture={pic17}/>
            <PaintingItem name={'Indian River Inlet'} picture={pic16}/>
            <PaintingItem name={'Point Loma'} picture={pic15}/>
            <PaintingItem name={'Ocean Beach'} picture={pic14}/>
            <PaintingItem name={'San Diego Bay'} picture={pic13}/>
            <PaintingItem name={'Sunset Cliffs Sea Cave'} picture={pic12}/>
            <PaintingItem name={'Ocean Beach Farmers Market'} picture={pic11}/>
            <PaintingItem name={'Sunset Cliffs'} picture={pic10}/>
            <PaintingItem name={'Hotel del Coronado'} picture={pic9}/>
            <PaintingItem name={'Ocean Beach'} picture={pic8}/>
            <PaintingItem name={'Ocean Beach'} picture={pic7}/>
            <PaintingItem name={'Ocean Beach'} picture={pic6}/>


        </div>
    </div>
}

